export default () => {
    return window.location.hash.substring(1)
                .split('&')
                .filter(pair => !!pair)
                .map(pair => pair.split('='))
                .filter(pair => pair.length === 2)
                .reduce((carry, current) => {
                    const [key, val] = current
                    return Object.assign(carry, { [key]: parseInt(val, 10) })
                }, {})
}